export const SUBSCRIPTION_SLIDER_AUTOPLAY_DELAY = 5000;

export const SUBSCRIPTION_SLIDER_BREAKPOINTS = {
   sm: {
      gutter: 16,
      slidesToShow: 2,
      slidesToScroll: 2,
      seekGap: 12,
   },
   md: {
      gutter: 16,
      slidesToShow: 4,
      slidesToScroll: 4,
      seekGap: 12,
   },
   lg: {
      gutter: 36,
      slidesToShow: 6,
      slidesToScroll: 6,
      seekGap: 0,
   },
};

export const SUBSCRIPTIONS_SECTION_TEST_ID = {
   slider: 'slider',
   prevSlideButton: 'prevSlideButton',
   nextSlideButton: 'nextSlideButton',
   slide: 'slide',
   currentBannerDiv: 'currentBannerDiv',
};
